/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// import useStyles from '../Component/Theme_1/ComponentCss';
import ThemeControls from "../Component/AllThemesControl";
import { Form } from '../Component/Forms/formElement';
import Button from './Button';
import FormRenderer from '../Component/Forms/FormRenderer'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
//validation 
import elementValidation from '../Component/validation.js';
//json context
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';
//APISERVICES
import { APIPOST, APIPATCH, APIGET } from '../services/APIServices';
//Importing the navigation purposes.. 
import { useNavigate } from 'react-router-dom';
import { MasterContext } from '../services/MasterContext';


import Dialog from '@mui/material/Dialog';

import Slide from '@mui/material/Slide';

import EmailTemplateForm from '../Component/Template/EmailTemplate.js'

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other} >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function GetTabPanels({jsonContext, _index, count, actionName,value, generateHandle,btnLoading}) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const { contextJson, id, apiContextObj, contextObjective, editData, contextDataArr, contextIndex,setLoading} = React.useContext(FormJSONCreateContext);
  const [reset, setReset] = React.useState(false)

  React.useMemo(() => {

    const resetFields = () => {
      Object.keys(contextJson).forEach((key, index) => {
        if (key !== "xioFEConfig") {
          contextJson[key].fields.forEach((field) => {
            if (contextObjective === "create" || contextObjective === "send" || contextObjective === "report") {
              if (field.field_type === "custom") {
                field.field_value = "{}"
              } else if (field.field_default_value) {
                field.field_value = field.field_default_value
                field.id = ""
              } else {
                field.field_value = ""
                field.id = ""
              }
            } else if (contextObjective === "search" || contextObjective === "remove") {
              if (field.field_default_value) {
                field.field_value = field.field_default_value
                field.id = ""
              } else {
                field.field_value = ""
                field.field_SearchValue = ""
                field.id = ""
              }
            } else if (contextObjective === "update") {
              field.field_value = editData[field.field_id]
            }

            let _te = document.getElementById(field.field_id);
            if (_te !== null)
              try {
                _te.parentNode.nextSibling.textContent = '';
              } catch (ex) {
                 
                 
              }
          })
        }
      })
    }

    if (reset) {
      resetFields()
      setReset(false)
    }
  }, [reset, contextObjective, contextDataArr, contextIndex, contextJson])

  const handleResetClick = (event) => {
    event.preventDefault();
    setReset(true);
  };

  return (
    <TabPanel value={value} index={_index}>
      <FormRenderer formJSON={jsonContext} />
      <div className={classes.ctaNxtPrv}>
        {(_index === 0 ? <Button
          className={classes.btnRset}
          ButtonName="Reset" onClick={handleResetClick}
        /> : null
        )}
        {(_index === 0 ? null :
          <Button
            className={classes.btnBck}
            ButtonName="Back"
            // onClick={() => handleTabChange(window.event, (_index - 1))}
          />
        )}
        {/* {(count===_index ? <Button ButtonStyle={{"background-color":'#82A9BB',
               "border-color":'#82A9BB'}}
                  ButtonName="Draft" onClick={(event)=>{event.preventDefault();}}/> :
                 <Button  ButtonStyle={{"background-color":'#82A9BB',
               "border-color":'#82A9BB'}}
                  ButtonName="Draft" onClick={(event)=>{event.preventDefault();}}/>
                )} */}
        {(count === _index ? null :
          <Button
            className={classes.btnDflt}
            ButtonName="Next"
            // onClick={() => localValidate(window.event, this, (_index + 1), jsonContext)}
          />
        )}
        {(count === _index&&apiContextObj?.requestSubmit?.auth ? <Button field_disabled=""
          className={classes.btnGen} onClick={generateHandle}
          ButtonName={apiContextObj?.requestSubmit?.buttonName}
        /> : null
        )}
        {(count === _index ? <Button field_disabled={btnLoading}
          className={classes.btnSmt}
          ButtonName={btnLoading?
            <div class={classes.loading08}>
              <span data-text="L">L</span>
              <span data-text="O">O</span>
              <span data-text="A">A</span>
              <span data-text="D">D</span>
              <span data-text="I">I</span>
              <span data-text="N">N</span>
              <span data-text="G">G</span>
            </div>:actionName}
        /> : null
        )}
      </div>
    </TabPanel>);
}

function TabPanels({actionName, value, generateHandle, btnLoading}) {
  const { contextJson } = React.useContext(FormJSONCreateContext);
  let objData = new Array();
  //objData.
  var index = 0;
  var Count = Object.keys(contextJson).length - 1;
  Object.keys(contextJson).forEach(key => {
    if (key !== "xioFEConfig") {
      objData[index] = (<GetTabPanels jsonContext={contextJson[key]} _index={index} count={Count - 1} actionName={actionName} value={value} generateHandle={generateHandle} btnLoading={btnLoading}/>);
      index++;
    }
  });
  return objData;
}



export default function BasicTabs(props) {
  const { useStyles } = ThemeControls;
  const { renderSuccessPage, apiString, setSubResponse } = React.useContext(FormJSONCreateContext);
  const { contextJson, id, apiContextObj, contextObjective, editData, contextDataArr, contextIndex,setLoading} = React.useContext(FormJSONCreateContext);
  const { masterData,userRole } = React.useContext(MasterContext);

  const classes = useStyles();
  let navigate = useNavigate()
  const [postResponse, setPostResponse] = React.useState();
  const [resWaiting, setResWaiting] = React.useState();
  // const [removeResponse, setremoveResponse] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [msgtype, setMsgType] = React.useState('error');
  const [generate, setGenerate] = React.useState(false)
  //Tab index
  const [value, setValue] = React.useState(0);
  const [disableBtn, setDesable] = React.useState(false);
  var objData = [];
  const [actionName, setActionName] = React.useState("Search");
  const [contextObj, setContextObj] = React.useState(contextObjective);
  const [btnLoading, setBtnLoading] = React.useState(false);

  React.useEffect(() => {
    handleContextObjective(contextObj)
  }, [])


  const handleContextObjective = (buttonName) => {
    switch (buttonName) {
      case "search":
        setActionName("Search");
        break;
      case "report":
        setActionName("Search");
        break;
      case "create":
        setActionName("Add");
        break;
      case "send":
        setActionName("Send");
        break;
      case "update":
        setActionName("Update");
        break;
      default:
        setActionName("Add");
        break;
    }
  };


  const handleClickOpen = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };


  function getSuccessResponse(res) {
    if (res.dataRecevied) {
      if(contextObj === "report"){
        if (res.dataRecevied.data) {
          apiString('', res.dataRecevied.data)
          setLoading(false)
          setBtnLoading(false)
        } else {
          apiString('', [])
          setLoading(false)
          setBtnLoading(false)
        }
      }
      if ((res.dataRecevied.statusCode === "SUCCESS"  || res.dataRecevied.statusCode === "Success") && contextObj !== "report") {
        let msg = 'Data has been successfully added';
        hendleErrorMsg(msg,'success')
        setBtnLoading(false)
        setSubResponse(res=>!res)
      }
    }
  }

  function getSuccessResReq(res) {
    // console.log(res)
    if (res.dataRecevied) {

      if (res.dataRecevied.statusCode === "SUCCESS"  || res.dataRecevied.statusCode === "Success") {
        let msg = 'Data has been successfully Submitted';
        hendleErrorMsg(msg, 'success')
        setBtnLoading(false)
        setSubResponse(res=>!res)
      }
    }
  }

  function getSuccessResponseUpdate(res) {
    // console.log(res)
    if (res.dataRecevied) {
      if (res.dataRecevied.statusCode === "SUCCESS") {
        let msg = 'Data has been successfully Updated';
        hendleErrorMsg(msg,'success')
        setBtnLoading(false)
        setSubResponse(res=>!res)
      }
    }
  }

  function hendleErrorMsg(msg,error) {
    if (msg.error === true) {
      if (msg.serverMessages) {
        setBtnLoading(false)
        const keys = Object.keys(msg.serverMessages);
        Object.keys(contextJson).forEach((key, _i) => {
          if (key !== "xioFEConfig") {
            // isFormValid = (validateThisForm(_object));
            contextJson[key].fields.forEach((field) => {
              keys.forEach((fieldKey) => {
                if (field.field_id === fieldKey) {
                  field.field_helperText = msg.serverMessages[fieldKey];
                }
              });
            });
            // //console.log(_i)
            handleTabChange(window.event, 0);
          }
        });
        setOpen(true)
        setErrorMsg(msg.serverMsg)
        setDesable(false)
        setMsgType(error)
      } else {
        setBtnLoading(false)
        setOpen(true)
        setErrorMsg(msg.serverMsg)
        setDesable(false)
        setMsgType(error)
        handleTabChange(window.event, 0);
      }
    } else {
      setBtnLoading(false)
      setOpen(true)
      setErrorMsg(msg)
      setMsgType(error)
      setDesable(false)
      if(contextObj === "report"){
        setLoading(false)
        if(msg==="Data Not Found"){
          apiString('', [])
        }else{
          apiString('', {})
        }
      }
    }
  }

  const handleTabChange = (event, newValue) => {
    event.preventDefault();
    window.scrollTo(0, 0);
    // console.warn(newValue)
    setValue(newValue);
  };

  function TabsTops(props) {
    const { contextJson } = React.useContext(FormJSONCreateContext);
    var __index = 0;
    if (Object.keys(contextJson).length > 1)
      Object.keys(contextJson).forEach((key, index) => {
        if (key !== "xioFEConfig")
          objData[index] = (getTopTabObject(contextJson[key].page_label, __index));
        __index++;
      });
    let retrunData;
    for (let _i = 0; _i < objData.length; ++_i) {

    }
    return Object.keys(objData).map((key) => {
      return objData[key];
    })

  }
  function getTopTabObject(_string, _index) {
    let _id = "simple-tab-" + _index;
    let ariaControls = "simple-tabpanel-" + _index;
    return (<Tab className={classes.hello} label={_string} onChange={() => handleTabChange(window.event, _index)} tabIndex={_index} aria-selected="true" id={_id} aria-controls={ariaControls} />);

  }
 
  function localValidate(event, obj, _index, jsonContext) {
    event.preventDefault();
    window.scrollTo(0, 0);
    //console.log(validateThisForm(jsonContext))
    if (validateThisForm(jsonContext)) {
      handleTabChange(window.event, _index);
      return true;
    } else {
      return false;
    }
    //return 
  }
 

  function validateThisForm(jsonContext) {
    let return_error = true;
    jsonContext.fields.forEach(field => {
      if (!elementValidation(field)) {
        return_error = false;
         
        return false;
      }
    });
    return return_error;
  }

  /////************************//////////

  function generateHandle(event) {
    event.preventDefault();
    let isFormValid = true;
    const generateData={}
    Object.keys(contextJson).forEach((key, _i) => {
      if (key !== "xioFEConfig") {
        let _object = contextJson[key];
        if (isFormValid) {
          isFormValid = (validateThisForm(_object));
          if (isFormValid) {
            _object.fields.forEach(thisField => {
              if (thisField.field_type === "multiSelect") {
                generateData[thisField.field_id] = thisField.field_value;
              } else {
                generateData[thisField.field_id] = thisField.field_value;
              }
            });
            // setDesable(true)
          } else {
            setDesable(false)
          }
        }
      }
    }
    );

    async function postingData(contextJson, data) {
      masterData[`${apiContextObj.apiContextSave}`] = {}
      const path = apiContextObj?.requestSubmit?.apiContext;
      
     
      try {
        const response = await APIPOST(path, data, contextJson, getSuccessResReq, hendleErrorMsg);
        if (response) {
          return response.data
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }
    if (isFormValid) {
    postingData(contextJson, generateData);
    }
  }

  //handle submit ------------>

  async function handleSubmit(event) {
    event.preventDefault();
    window.scrollTo(0, 0);
    let isFormValid = true;
    const defaultData = {};
    const formData = {}
    let data = {}
 

    Object.keys(contextJson).forEach((key, _i) => {
      if (key !== "xioFEConfig") {
        let _object = contextJson[key];
        if (isFormValid) {
          isFormValid = (validateThisForm(_object));
          if (isFormValid) {
            _object.fields.forEach(thisField => {
              if (thisField.field_type !== "multiSelect" && thisField.field_type !== "date" && thisField.field_type !== "qRCode" && thisField.field_type !== "formJsonData") {
                formData[thisField.field_id] = thisField.field_value;
              } else if (thisField.field_type === "qRCode") {
                formData[thisField.field_id] = thisField.field_value;
                formData[thisField.field_keyValue] = thisField.url;
              } else if (thisField.field_value === "formJsonData") {
                formData[thisField.field_id] = JSON.stringify(thisField.field_value);
              }
              else {
                formData[thisField.field_id] = thisField.field_value;
                // formData[thisField.field_id] = String(thisField.field_value);
              }
            });
            // setDesable(true)
          }
          else {
            handleTabChange(window.event, _i);
            setDesable(false)
            setBtnLoading(false)
          }
        }
      }
    }
    );
    data = {
      ...formData,
      ...defaultData
    };

      //********post******** */
  async function postingData(contextJson) {
    masterData[`${apiContextObj.apiContextSave}`] = {}
    let path = ''
    if (contextObj === "report") {
      path = apiContextObj.apiContextSave;
      setLoading(true)
    } else {
      path = apiContextObj.apiContextSave + '/save'
    }
    try {
      const response = await APIPOST(path, data, contextJson, getSuccessResponse, hendleErrorMsg);
      if (response) {
        return response.data
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
//********patch******** */
  async function updateData(contextJson) {
    masterData[`${apiContextObj.apiContextSave}`] = {}
    try {
      const response = await APIPATCH(apiContextObj.apiContextSave + '/' + contextDataArr[contextIndex][apiContextObj.id], data, contextJson, getSuccessResponseUpdate, hendleErrorMsg);
      if (response) {
        return response.data
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

    async function getData() {
      let formattedString = "";
      // console.log(formData)
      for (const key in formData) {
        const value = formData[key];
        if (value && key) {
          formattedString += `${key}=${encodeURIComponent(value)}&`;
        }
      }
    
      // apiString(apiContextObj.apiContextSearch + '/filter?' + formattedString);
      const pathStr = apiContextObj.apiContextSearch.split('/')[0]
      const pathArry = apiContextObj.apiContextSearch.split('/')
      const lastSegment = pathArry[pathArry.length-1];
      if(pathStr === 'mm'){
        apiString(apiContextObj.apiContextSearch + formattedString);
        localStorage.setItem('filterValue', apiContextObj.apiContextSearch + formattedString);
      }else if(pathStr==="ratesheet"&&(lastSegment==="amWiseReport" || lastSegment==="getRateHistory" || lastSegment==="destinationWiseReport" || lastSegment==="customerRateDetail" || lastSegment==="floorRateReport" || lastSegment==="completedealMarginReport" || lastSegment==="AM90DaysReport" || lastSegment==="missingInvoiceReport" || lastSegment==="varianceInvoiceReport" || lastSegment==="carrierDueAmountReport" || lastSegment==="dealPerformanceReport" || lastSegment==="lcrReport")){
        apiString(apiContextObj.apiContextSearch + '?' + formattedString);
      }else{
        apiString(apiContextObj.apiContextSearch + '/filter?' + formattedString);
        localStorage.setItem('filterValue', apiContextObj.apiContextSearch + '/filter?' + formattedString);
      }

      setTimeout(() => apiString(), 1000)

    }


    if (isFormValid) {
      if (contextObj === "create") {
        postingData(contextJson);
      } else if (contextObj === "report") {
        setBtnLoading(true)
        postingData(contextJson);
      } else if (contextObj === "send") {
        handleClickOpen()
      } else if (contextObj === "update") {
        updateData(contextJson)
      } else if (contextObj === "search" || contextObj === "remove") {
          getData();
      }
    } else {
      // alert("Please check form for errors");
      var msg = 'Please Check Form for errors!';
      hendleErrorMsg(msg,'error')
    }
    return false;
  }



  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function handelnavigate(event, link) {
    event.preventDefault();
    navigate(link)
  }

  const contextClass = props.contextClass;
  let ShowTopTabs = false;
  if (Object.keys(contextJson).length > 2) {
    ShowTopTabs = true;
  }
  TabsTops();

  // const alertTypeValue = contextJson?.Parameter?.fields.find(field => field.field_id === "AlertType").field_value;
  // //console.log(alertTypeValue)

  function checkRoutesAuth(context) {
    // console.log(context);
    const permissions = userRole?.data?.filter(permission => permission.applicationcontext === context);
    // console.log(permissions);
    
    if (permissions && permissions.length > 0) {
        for (const permission of permissions) {
            if (permission.accessPersmission === 1 && permission.saveP === 1) {
                return true;
            }
        }
    }
    
    return false;
  }

  return (
    <React.Fragment >
      <Snackbar className={classes.errorpopup} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={msgtype} sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog
        // open='true'
        open={openAlert}
        maxWidth='lg'
        onClose={handleCloseAlert}
      >
        {/* {alertTypeValue==='4'?<h2>reminder</h2>: */}
        <EmailTemplateForm close={handleCloseAlert} contextJson={contextJson} />
        {/* } */}
      </Dialog>
      <Form onSubmit={handleSubmit}>
        {ShowTopTabs === true ? <Box className={contextClass}>
          <Box className={classes.formtab} sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleTabChange} aria-label="">
              {/* <TabsTops /> */}
              {(Object.keys(contextJson).length > 1) ?
                Object.keys(contextJson).map((key, index) => {
                  if (key !== "xioFEConfig") {
                    // objData[index] =  (getTopTabObject(contextJson[key].page_label,index));
                    return (<Tab label={contextJson[key].page_label} onChange={() => handleTabChange(window.event, index)} tabIndex={index} aria-selected="true" id={"simple-tab-" + index} aria-controls={"simple-tabpanel-" + index} />)
                  }
                }) : null}
              {/* {Object.keys(objData).map((key, idx) => (
            <Tab/>
          ))} */}
            </Tabs>
          </Box>

          <TabPanels actionName={actionName} value={value} generateHandle={generateHandle} btnLoading={btnLoading}/>
        </Box>
          : <Box className={contextClass}>
            {Object.keys(contextJson).map((key, index) => {
              if (key !== "xioFEConfig") {
                return (
                  <>
                    {contextJson[key].page_label && <div className={classes.formTabheading}>
                      {contextJson[key].page_label && <h1>{contextJson[key].page_label}</h1>}
                      {contextJson[key].btn_name && checkRoutesAuth(apiContextObj?.applicationContext) && (
                        <button className={classes.subBtn} onClick={(event) => handelnavigate(event, contextJson[key].btn_link)}>
                          {contextJson[key].btn_name}
                        </button>
                      )}
                    </div>}
                  </>
                );
              }
              return null;
            })}
            <TabPanels actionName={actionName} value={value} generateHandle={generateHandle} btnLoading={btnLoading}/>
          </Box>


        }
      </Form>
    </React.Fragment>
  )
}

